import React from "react";
import Layout from "layouts";
import DeliveryTicketComponent from "./DeliveryTicketComponent";

export default function DeliveryZone() {
  return (
    <Layout breadCrumb={[{ label: "Delivery Tickets", to: "#" }]}>
      <DeliveryTicketComponent />
    </Layout>
  );
}
